var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "child",
    transform: "translate(-455 -535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4278",
    "data-name": "Rectangle 4278",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 535)",
    fill: "#ffe8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boy",
    d: "M43.571,26.08a1.4,1.4,0,0,0-1.7-1A49.272,49.272,0,0,1,28.96,27.01a53.73,53.73,0,0,1-12.935-1.934,1.4,1.4,0,1,0-.672,2.711,75.527,75.527,0,0,0,8.2,1.633l1.212.161v7.654L23.38,48.321a1.4,1.4,0,0,0,2.758.43L28.232,37.58a1.4,1.4,0,0,0,.024-.252h2.793a1.4,1.4,0,0,0,.024.252l2.095,11.171a1.4,1.4,0,0,0,2.758-.43L34.54,37.236V29.444l1.178-.186c2.121-.336,4.365-.827,6.854-1.475A1.4,1.4,0,0,0,43.571,26.08Zm-2.407-3.7a4.189,4.189,0,1,1,2.111,8.108c-2.106.548-4.066.993-5.943,1.331v5.246L38.7,47.974a4.189,4.189,0,0,1-8.274,1.292l-.77-4.106-.77,4.106a4.189,4.189,0,0,1-8.274-1.292l1.364-10.912V32.014c-2.289-.356-4.68-.869-7.291-1.516A4.189,4.189,0,0,1,16.7,22.366a51.017,51.017,0,0,0,12.274,1.852A46.547,46.547,0,0,0,41.164,22.378ZM28.954,10.793a4.189,4.189,0,1,0,4.189,4.189A4.189,4.189,0,0,0,28.954,10.793Zm-6.982,4.189a6.982,6.982,0,1,1,6.982,6.982A6.982,6.982,0,0,1,21.973,14.982Z",
    transform: "translate(472.501 551)",
    fill: "#b92626",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.a2116dc1401ba860e03356b12247f74d.svg";
export { ForwardRef as ReactComponent };